import { Link, useLocation } from 'react-router-dom';
import { ArrowRight, CheckCircle2 } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { Card, CardContent } from '@/components/ui/card';
import { useLang } from '@/contexts/LangContext';

function pickText(lang, arText, enText) {
  return lang === 'ar' ? arText : enText;
}

export default function ThankYouPage() {
  const { lang } = useLang();
  const location = useLocation();
  const submissionContext = location.state && typeof location.state === 'object' ? location.state : {};
  const hasVerifiedSubmission = submissionContext.verified_submission === true;

  return (
    <div data-testid="thank-you-page" className="bf-page-canvas bg-[#f4f5f7] px-4 py-16 text-[#231f20] dark:bg-[#231f20] dark:text-[#e6e6e6] sm:px-6 lg:px-8 lg:py-24">
      <div className="mx-auto max-w-4xl">
        <Card className="overflow-hidden rounded-[2.25rem] border border-[#d8dde6] bg-white shadow-[0_28px_80px_-46px_rgba(15,23,42,0.45)] dark:border-white/10 dark:bg-white/5 dark:shadow-none">
          <CardContent className="relative p-8 text-center sm:p-10 lg:p-14">
            <div className="pointer-events-none absolute inset-x-0 top-0 h-1 bg-[#6c8bc6]" />
            <div className="mx-auto flex h-16 w-16 items-center justify-center rounded-full bg-[#6c8bc6]/12 text-[#6c8bc6]">
              <CheckCircle2 className="h-8 w-8" />
            </div>
            <p className="bf-brand-kicker mt-6 text-[#6c8bc6]">
              {pickText(lang, 'تم استلام الطلب', 'Request received')}
            </p>
            <h1 className="bf-page-display mt-4">
              {pickText(lang, 'شكراً لك!', 'Thank you!')}
            </h1>
            <p className="bf-page-copy mx-auto mt-5 max-w-2xl text-[#231f20]/72 dark:text-[#e6e6e6]/76">
              {pickText(
                lang,
                'تم استلام طلبك بنجاح. سيتواصل معك أحد مستشارينا قريباً.',
                'Your request has been received successfully. One of our advisors will contact you soon.'
              )}
            </p>
            {!hasVerifiedSubmission ? (
              <p className="mx-auto mt-4 max-w-xl text-sm leading-7 text-[#231f20]/54 dark:text-[#e6e6e6]/58">
                {pickText(
                  lang,
                  'إذا وصلت إلى هذه الصفحة مباشرة، يمكنك متابعة تصفح الموقع أو التواصل معنا من خلال صفحة الاتصال.',
                  'If you opened this page directly, you can continue browsing or contact us from the contact page.'
                )}
              </p>
            ) : null}
            <div className="mt-9 flex flex-col justify-center gap-3 sm:flex-row">
              <Link to="/">
                <Button className="bf-premium-cta h-12 rounded-full bg-[#6c8bc6] px-7 text-white hover:bg-[#5876b0]">
                  {pickText(lang, 'الرئيسية', 'Back to Home')}
                  <ArrowRight className="ml-2 h-4 w-4" />
                </Button>
              </Link>
              <Link to="/courses">
                <Button variant="outline" className="bf-outline-button h-12 rounded-full px-7">
                  {pickText(lang, 'عرض الدورات', 'View Courses')}
                </Button>
              </Link>
              <Link to="/contact">
                <Button variant="outline" className="bf-outline-button h-12 rounded-full px-7">
                  {pickText(lang, 'تواصل معنا', 'Contact Us')}
                </Button>
              </Link>
            </div>
          </CardContent>
        </Card>
      </div>
    </div>
  );
}
